<template>
    <b-modal size="lg" title="Print SOP" hide-footer id="printSopModal">
        <b-overlay :show="busySaving || !hasMounted">
            <div class="modal-body" style="width: 100%;">
                <b-form @submit="savePrintSOP" @reset="resetPrint">
                    <b-row>
                        <b-col cols="6">
                            <b-form-group id="name" label="Copy Holder Name:" label-for="name-input">
                                <b-form-input id="name-input" v-model="printData.copy_holder_name" placeholder="Name of copy holder" required></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group id="email" label="Copy Holder Email:" label-for="email-input">
                                <b-form-input id="email-input" v-model="printData.copy_holder_email" type="email" placeholder="Copy holder email" required></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <div style="margin-top: 10px;"></div>
                            <b-form-group label="Distribution Type:">
                                <b-form-select
                                    class="form-select"
                                    :options="typeOpts"
                                    v-model="printData.copy_type"
                                    required
                                ></b-form-select>
                            </b-form-group> 
                        </b-col>
                        <b-col class="mt-3" cols="12">
                            <b-form-group id="reason" label="Reason" label-for="reason-input">
                                <b-form-textarea id="reason-input" v-model="printData.reason_for_copy" rows="4" no-resize placeholder="Reason for copy"></b-form-textarea>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <div class="modal-footer">
                        <button class="btn btn-primary" type="submit">Print</button>
                        <button type="button" class="btn btn-secondary" @click="hideModal()">Close</button>
                    </div>
                </b-form>
            </div>
        </b-overlay>
    </b-modal>
</template>
<script>
//import _ from 'lodash';
//import Swal from "sweetalert2";
import print from 'print-js'
import { sopMethods, sopState } from '@/state/helpers.js'
export default {
    props:{
        //views:{},
        sop_revision: {}
    },
    data:() => ({
        hasMounted: false,
        busySaving: false,
        printData: {
            //client_revision_id: "",
            copy_holder_name: "",
            copy_holder_email: "",
            reason_for_copy: "",
            copy_type: ""
        },
        typeOpts: [
            { value: '', text: 'Please select an option'},
            { value: 'authorised', text: 'Authorised Copy' },
            { value: 'internal', text: 'Internal Copy' },
            { value: 'uncontrolled', text: 'Uncontrolled Copy' }
        ],
    }),
    computed:{
        ...sopState,
        /*return_views(){
            let data = [];
            if(this.views != null){
                data = _.cloneDeep(this.views);
            }
            return data;
        }*/
    },
    methods:{
        ...sopMethods,
        savePrintSOP(event) {
            event.preventDefault();
            this.busySaving = true;
            this.printData['client_revision_id'] = this.sop_revision.client_revision_id;
            window.axios.post('api/clientdocadmin/printablesop', this.printData)
            .then( (response) =>{
                print({printable: response.data.pdf_64, type: 'pdf', base64: true});
                this.busySaving = false;
                this.resetPrint();
                this.hideModal();
            })
            .catch((error)=>{
                console.log(error)
                //reject();
            })
        },
        resetPrint() {
            this.printData = {
                copy_holder_name: "",
                copy_holder_email: "",
                reason_for_copy: "",
                copy_type: ""
            };
        },
        hideModal() {
            this.$bvModal.hide("printSopModal");
        },

     },
    mounted(){
        setTimeout(()=>{
            this.hasMounted = true;
        }, 300)
    },
}
</script>